import { Routes } from '@angular/router';
import { MainLayoutComponent } from './core/layout/main-layout/main-layout.component';
import { NotFoundComponent } from './core/layout/not-found/not-found.component';
import { MsalGuard } from '@azure/msal-angular';
import { authGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      {
        path: 'home',
        loadComponent: () =>
          import('./core/features/home/home.component').then(
            (m) => m.HomeComponent
          ),
        canActivate: [MsalGuard, authGuard],
      },
      {
        path: 'projects',
        loadComponent: () =>
          import('./core/features/projects/projects-grouped/projects-grouped.component').then(
            m => m.ProjectsGroupedComponent,
          ),
        canActivate: [MsalGuard, authGuard],
      },
      {
        path: 'lessons-learning/:id',
        loadComponent: () =>
          import(
            './core/features/lessons/lessons-learning/lessons-learning.component'
          ).then((m) => m.LessonsLearningComponent),
        canActivate: [MsalGuard, authGuard],
      },
      {
        path: 'user-no-permission',
        loadComponent: () =>
          import(
            './core/layout/user-no-permission/user-no-permission.component'
          ).then((m) => m.UserNoPermissionComponent),
        canActivate: [MsalGuard],
      },
      {
        path: 'knowledge',
        loadComponent: () =>
          import(
            './core/features/knowledge/knowledge-general/knowledge-general.component'
          ).then((m) => m.KnowledgeGeneralComponent),
        canActivate: [MsalGuard, authGuard],
      },
      {
        path: 'knowledge/:id',
        loadComponent: () =>
          import(
            './core/features/knowledge/knowledge-general/knowledge-general.component'
          ).then((m) => m.KnowledgeGeneralComponent),
        canActivate: [MsalGuard, authGuard],
      },
      {
        path: 'open-pill/:id/:idProject/:type',
        loadComponent: () =>
          import(
            './core/features/knowledge/similar-project-open/similar-project-open.component'
          ).then((m) => m.SimilarProjectOpenComponent),
        canActivate: [MsalGuard, authGuard],
      },
      {
        path: 'lessons-view/:id/:lessonId/:edit',
        loadComponent: () =>
          import(
            './core/features/lessons/components/lesson-view/lesson-view.component'
          ).then((m) => m.LessonViewComponent),
        canActivate: [MsalGuard, authGuard],
      },
    ],
  },
  { path: '**', component: NotFoundComponent },
];
